/**
 * Utility function to get the application version
 * Tries to fetch from app_version.config file in public folder,
 * falls back to a default version if unavailable
 */
let cachedVersion = null;

export const getAppVersion = async () => {
  if (cachedVersion) {
    return cachedVersion;
  }

  try {
    // Try to fetch from public folder
    const response = await fetch("/app_version.config");
    if (response.ok) {
      const text = await response.text();
      const match = text.match(/app_version=(.+)/);
      if (match && match[1]) {
        cachedVersion = match[1].trim();
        return cachedVersion;
      }
    }
  } catch (error) {
    console.warn("Could not fetch app version from config file:", error);
  }

  // Fallback to default version
  cachedVersion = "1.0.1";
  return cachedVersion;
};

/**
 * Synchronous version getter (uses cached value or default)
 * Use this for immediate rendering, but it may return default initially
 */
export const getAppVersionSync = () => {
  return cachedVersion || "1.0.1";
};
